// test2455
(2455 && 0);
